import { render } from "./AddToWeitlistModal.vue?vue&type=template&id=2146c758&scoped=true&ts=true&lang=pug"
import script from "./AddToWeitlistModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddToWeitlistModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddToWeitlistModal.vue?vue&type=style&index=0&id=2146c758&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2146c758"]])

export default __exports__